import React, {useEffect, useState} from 'react';
import './index.scss'
import {intermediateText} from "../utils/intermediateText";
import {Link, useParams} from "react-router-dom";
const Intermediate = () => {
    const {id} = useParams()
    const [params, setParams] = useState(intermediateText[0])
    useEffect(()=>{
        console.log(intermediateText)
        if(id === '2'){
            setParams(intermediateText[0])
        } else if(id === '4'){
            setParams(intermediateText[1])
        }
    },[id])
    return (
        <div className='IntermediateContainer'>
            <div className={'wrap'}>
                <div className={'title'}>{params[0]}</div>
                <div className={'title'}>{params[1]}</div>

                <button className={'job'} onClick={()=>{
                    window.open('http://career.nipigas.ru/studentam/programma-molodoy-spetsialist/')
                    // @ts-ignore
                    {id === '2'? ym(95273517,'reachGoal','vacancy1'): ym(95273517,'reachGoal','vacancy2')}
                }}>К вакансиям!</button>
                <div className={'title'}>{params[2]}</div>
                <Link to={`/game/${Number(id) + 1}`}>
                <button className={'next'} onClick={()=>{
                    {id === '2'?
                            // @ts-ignore
                        ym(95273517,'reachGoal','go1'):ym(95273517,'reachGoal','go2')}
                }}>Продолжить</button>
                </Link>
            </div>
        </div>
    );
};

export default Intermediate;
